var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Search } from "@mui/icons-material";
import { Button, Chip, CircularProgress, Stack, Typography, useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import { useSelector } from "react-redux";
import { getNpsRatingByChasis } from "../../../api/url";
import { ReactComponent as LeftArrow } from '../../../assets/images/arrow-left.svg';
import { ReactComponent as VerifiedIcon } from '../../../assets/images/check-verified.svg';
import { ReactComponent as ClearIcon } from '../../../assets/images/crossCircleIocn.svg';
import { ReactComponent as DownArrow } from '../../../assets/images/downArrow.svg';
import { ReactComponent as LocationIcon } from '../../../assets/images/LocationIcon.svg';
import { ReactComponent as MailIcon } from '../../../assets/images/mailSvg.svg';
import { ReactComponent as UpArrow } from '../../../assets/images/newUpArrow.svg';
import { ReactComponent as NoDocumenetsIcon } from '../../../assets/images/NoDocuments.svg';
import { getLoadingKey } from "../../../builderPackage/common/commonFunctions";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { DesktopTabComponent } from "../../../components/molecules/desktopTabComponent";
import NpsChip from "../../../components/molecules/NPSChip";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import { getListAPI, setReducerState } from "../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { info } from "../../../theme/colors";
import { getStatusColor } from "../../../theme/statusColors";
import { CustomerHistoryCatalogView } from "../component/customerHistoryCatalogView";
import { CustomerHistoryMobileView } from "../component/customerHistoryMobileView";
import { JobCardDetailsCatalogView } from "../component/jobCardDetailsCatalogView";
import { JobCardDetailsMobile } from "../component/jobCardDetailsMobile";
import { RecallDetailsCatalogView } from "../component/recallDetailsCatalogView";
import { RecallHistoryMobileView } from "../component/recallHistoryMobileView";
import { TransactionDetailsMobileView } from "../component/transactionDetailsMobileView";
import { TransactionHistoryCatalogView } from "../component/transactionHistoryCatalogView";
import { ViewServiceHistory } from "../component/viewSeviceHistory";
import { getCustomerDetailsAPI, InstallBaseListAPI, serviceHistoryAPI } from "../service/apiCall";
import { vehicleHistoryKeys } from "../service/entity";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
export var VehicleHistory = function (_ref) {
    var _crud$vehicleHistoryK7, _crud$vehicleHistoryK8, _crud$vehicleHistoryK9, _crud$vehicleHistoryK10, _crud$vehicleHistoryK11, _crud$vehicleHistoryK14, _crud$vehicleHistoryK15, _crud$vehicleHistoryK18, _crud$vehicleHistoryK19, _crud$vehicleHistoryK20, _crud$vehicleHistoryK21, _crud$vehicleHistoryK22, _crud$vehicleHistoryK23, _crud$vehicleHistoryK24, _crud$vehicleHistoryK25, _crud$vehicleHistoryK38, _crud$vehicleHistoryK39, _crud$vehicleHistoryK40, _crud$vehicleHistoryK41, _crud$vehicleHistoryK42, _crud$vehicleHistoryK43, _crud$vehicleHistoryK44, _crud$vehicleHistoryK45;
    var selectedVinNo = _ref.selectedVinNo, isRightDrawer = _ref.isRightDrawer, onClose = _ref.onClose;
    var commonState = useSelector(function (state) { return state.common; });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var crud = useAppSelector(function (state) { return state.crud; });
    var SELECTED_CHANNEL = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var dispatch = useAppDispatch();
    var isSearchLoading = [crud[getLoadingKey(vehicleHistoryKeys.InstallBaseListKey)], crud[getLoadingKey(vehicleHistoryKeys.CustomerDetailsKey)], crud[getLoadingKey(vehicleHistoryKeys.SeviceHistoryKey)]].includes('loading');
    var searchType = [{
            id: 'RegistrationNo',
            label: 'Reg. No.'
        }, {
            id: 'VinNo',
            label: 'VIN No.'
        }, {
            id: 'EngineNo',
            label: 'Engine No.'
        }];
    var fetchNpsByChassis = function (chassisNo) { return __awaiter(void 0, void 0, void 0, function () {
        var _res$payload$value$da, _res$payload, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getListAPI({
                        key: '',
                        url: getNpsRatingByChasis,
                        request: {
                            Chassis: chassisNo
                        }
                    }))];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, (_res$payload$value$da = res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.value) === null || _res$payload === void 0 ? void 0 : _res$payload.data) !== null && _res$payload$value$da !== void 0 ? _res$payload$value$da : []];
            }
        });
    }); };
    // const enrichFirstServiceDetailWithNps = async (ServiceDetails: ResponseArray) => {
    //     if (!ServiceDetails || ServiceDetails.length === 0) return [];
    //     const firstChassisNo = ServiceDetails[0]?.ChassisNo;
    //     const npsResponse = await fetchNpsByChassis(firstChassisNo);
    //     return ServiceDetails.map((item, index) => {
    //         if (index === 0) {
    //             return {
    //                 ...item,
    //                 NPSResponse: npsResponse
    //             };
    //         }
    //         return item;
    //     });
    // };
    var handleClickSearch = function (state, value) { return __awaiter(void 0, void 0, void 0, function () {
        var _getInstallbaseData5, _getServiceHistory, _getServiceHistory2, _existingInstallbase$, getInstallbaseData, getCustomerData, getServiceHistory, _getInstallbaseData, _getInstallbaseData2, _getCustomerData, _getCustomerData2, _getInstallbaseData3, _getInstallbaseData4, existingInstallbase, selectedStatus, filteredContracts, statusCounts, NPSResponse, _getInstallbaseData6, _getServiceHistory3, _getInstallbaseData7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(state.Key === 'VinNo' || state.Key === "RegistrationNo" || state.Key === "EngineNo" && state !== null && state !== void 0 && state.Value)) return [3 /*break*/, 5];
                    return [4 /*yield*/, InstallBaseListAPI({
                            request: {
                                Value: state === null || state === void 0 ? void 0 : state.Value,
                                Key: state === null || state === void 0 ? void 0 : state.Key
                            }
                        })];
                case 1:
                    getInstallbaseData = _a.sent();
                    if (!(((_getInstallbaseData = getInstallbaseData) === null || _getInstallbaseData === void 0 ? void 0 : _getInstallbaseData.statusCode) == 200 && (_getInstallbaseData2 = getInstallbaseData) !== null && _getInstallbaseData2 !== void 0 && _getInstallbaseData2.success)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getCustomerDetailsAPI({
                            request: {
                                id: (_getInstallbaseData3 = getInstallbaseData) === null || _getInstallbaseData3 === void 0 || (_getInstallbaseData3 = _getInstallbaseData3.data) === null || _getInstallbaseData3 === void 0 || (_getInstallbaseData3 = _getInstallbaseData3.Customer) === null || _getInstallbaseData3 === void 0 ? void 0 : _getInstallbaseData3.CustomerId
                            }
                        })];
                case 2:
                    getCustomerData = _a.sent();
                    _a.label = 3;
                case 3:
                    if (!(((_getCustomerData = getCustomerData) === null || _getCustomerData === void 0 ? void 0 : _getCustomerData.statusCode) == 200 && (_getCustomerData2 = getCustomerData) !== null && _getCustomerData2 !== void 0 && _getCustomerData2.success)) return [3 /*break*/, 5];
                    return [4 /*yield*/, serviceHistoryAPI({
                            request: {
                                InstallBaseId: (_getInstallbaseData4 = getInstallbaseData) === null || _getInstallbaseData4 === void 0 || (_getInstallbaseData4 = _getInstallbaseData4.data) === null || _getInstallbaseData4 === void 0 || (_getInstallbaseData4 = _getInstallbaseData4.InstallBase[0]) === null || _getInstallbaseData4 === void 0 ? void 0 : _getInstallbaseData4.InstallBaseId
                            }
                        })];
                case 4:
                    getServiceHistory = _a.sent();
                    _a.label = 5;
                case 5:
                    existingInstallbase = ((_getInstallbaseData5 = getInstallbaseData) === null || _getInstallbaseData5 === void 0 || (_getInstallbaseData5 = _getInstallbaseData5.data) === null || _getInstallbaseData5 === void 0 ? void 0 : _getInstallbaseData5.InstallBase) || [];
                    selectedStatus = "Active";
                    filteredContracts = filterContractsByStatus(((_getServiceHistory = getServiceHistory) === null || _getServiceHistory === void 0 || (_getServiceHistory = _getServiceHistory.data) === null || _getServiceHistory === void 0 ? void 0 : _getServiceHistory.IBContractDetails) || [], selectedStatus);
                    statusCounts = getContractStatusCounts(((_getServiceHistory2 = getServiceHistory) === null || _getServiceHistory2 === void 0 || (_getServiceHistory2 = _getServiceHistory2.data) === null || _getServiceHistory2 === void 0 ? void 0 : _getServiceHistory2.IBContractDetails) || []);
                    return [4 /*yield*/, fetchNpsByChassis((_existingInstallbase$ = existingInstallbase[0]) === null || _existingInstallbase$ === void 0 ? void 0 : _existingInstallbase$.VinNo)];
                case 6:
                    NPSResponse = _a.sent();
                    console.log('NPSResponse', NPSResponse);
                    if ((existingInstallbase === null || existingInstallbase === void 0 ? void 0 : existingInstallbase.length) > 0) {
                        return [2 /*return*/, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, getCustomerData), (_getInstallbaseData6 = getInstallbaseData) === null || _getInstallbaseData6 === void 0 ? void 0 : _getInstallbaseData6.data), (_getServiceHistory3 = getServiceHistory) === null || _getServiceHistory3 === void 0 ? void 0 : _getServiceHistory3.data), {}, {
                                InstallBase: existingInstallbase,
                                success: (_getInstallbaseData7 = getInstallbaseData) === null || _getInstallbaseData7 === void 0 ? void 0 : _getInstallbaseData7.success,
                                resultnotfound: false,
                                NewIBContractDetails: filteredContracts,
                                SelectedButton: 'Active',
                                statusCounts: statusCounts,
                                NPSResponse: NPSResponse
                                // NewServiceDetails: enrichedServiceDetails
                            })];
                    }
                    else {
                        return [2 /*return*/, {
                                resultnotfound: true,
                                success: false
                            }];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var filterContractsByStatus = function (contracts, selectedStatus) {
        var currentDate = new Date();
        return contracts.filter(function (contract) {
            var effectiveToDate = new Date(contract.EffectiveTo);
            var isAvailed = contract.IsAvailed === "Yes";
            var status = currentDate > effectiveToDate ? isAvailed ? "Availed" : "Expired" : isAvailed ? "Availed" : "Active";
            return status === selectedStatus;
        });
    };
    var getContractStatusCounts = function (contracts) {
        var currentDate = new Date();
        var counts = {
            Active: 0,
            Availed: 0,
            Expired: 0
        };
        contracts.forEach(function (contract) {
            var effectiveToDate = new Date(contract.EffectiveTo);
            var isAvailed = contract.IsAvailed === "Yes";
            var status = currentDate > effectiveToDate ? isAvailed ? "Availed" : "Expired" : isAvailed ? "Availed" : "Active";
            counts[status]++;
        });
        return counts;
    };
    var BasicAndVehicleDetails = [_objectSpread(_objectSpread({
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            // paddingX: '20px',
            hidden: selectedVinNo ? true : false
        }, selectedVinNo ? {} : {
            setFieldProps: function (state) { return ({
                type: FormItemTypes.ContainerItem,
                sx: {
                    display: state !== null && state !== void 0 && state.success && state !== null && state !== void 0 && state.Value ? undefined : 'none'
                }
            }); }
        }), {}, {
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    sx: {
                        border: '1px',
                        borderRadius: "12px",
                        borderColor: "secondary.200"
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: true,
                            fontWeight: "strong",
                            children: 'Basic details',
                            color: "text.primary",
                            fontSize: 'base'
                        }, {
                            type: FormItemTypes.IconButton,
                            name: ' basic-detail-dropdown-icon',
                            columnSize: 0,
                            children: isOpen ? /*#__PURE__*/ React.createElement(UpArrow, null) : /*#__PURE__*/ React.createElement(DownArrow, null),
                            setFormState: function (formValues, currValue) {
                                if (isOpen) {
                                    setIsOpen(false);
                                }
                                else {
                                    setIsOpen(true);
                                }
                                return {};
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            rowGap: 1,
                            columnSpacing: 2,
                            alignItems: 'start',
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: isRightDrawer ? 6 : 4,
                                    lg: isRightDrawer ? 6 : 4,
                                    xl: isRightDrawer ? 6 : 3,
                                    spacing: 0,
                                    rowGap: 1,
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            children: 'Customer details',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            color: 'text.secondary',
                                            columnSize: 12
                                        }, !isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: 'customer-details-card',
                                            columnSize: 12,
                                            sx: {
                                                padding: {
                                                    xs: 1.5
                                                }
                                            },
                                            contentProps: {
                                                spacing: 0
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 0,
                                                    spacing: 0,
                                                    columnGap: 1,
                                                    alignItems: 'center',
                                                    flexWrap: 'nowrap',
                                                    display: 'flex',
                                                    justifyContent: "space-between",
                                                    elements: [{
                                                            type: FormItemTypes.Box,
                                                            name: '',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: "center",
                                                            columnSize: 0,
                                                            gap: 1,
                                                            elements: [{
                                                                    type: FormItemTypes.Avatar,
                                                                    name: 'profile-icon',
                                                                    columnSize: 0,
                                                                    sx: {
                                                                        height: 24,
                                                                        width: 24
                                                                    }
                                                                }, {
                                                                    type: FormItemTypes.Typography,
                                                                    name: 'customer-name',
                                                                    columnSize: 0,
                                                                    fontWeight: 'medium',
                                                                    fontSize: 'base',
                                                                    color: 'text.primary',
                                                                    valueGetter: function (formData) {
                                                                        var _crud$vehicleHistoryK, _crud$vehicleHistoryK2, _crud$vehicleHistoryK3, _crud$vehicleHistoryK4;
                                                                        return "".concat((_crud$vehicleHistoryK = (_crud$vehicleHistoryK2 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK2 === void 0 || (_crud$vehicleHistoryK2 = _crud$vehicleHistoryK2.data) === null || _crud$vehicleHistoryK2 === void 0 || (_crud$vehicleHistoryK2 = _crud$vehicleHistoryK2.Person) === null || _crud$vehicleHistoryK2 === void 0 ? void 0 : _crud$vehicleHistoryK2.GivenName) !== null && _crud$vehicleHistoryK !== void 0 ? _crud$vehicleHistoryK : '-', " ").concat((_crud$vehicleHistoryK3 = (_crud$vehicleHistoryK4 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK4 === void 0 || (_crud$vehicleHistoryK4 = _crud$vehicleHistoryK4.data) === null || _crud$vehicleHistoryK4 === void 0 || (_crud$vehicleHistoryK4 = _crud$vehicleHistoryK4.Person) === null || _crud$vehicleHistoryK4 === void 0 ? void 0 : _crud$vehicleHistoryK4.FamilyName) !== null && _crud$vehicleHistoryK3 !== void 0 ? _crud$vehicleHistoryK3 : ' ');
                                                                    }
                                                                }]
                                                        }, {
                                                            type: FormItemTypes.Box,
                                                            name: '',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: "center",
                                                            textAlign: 'center',
                                                            columnSize: 0,
                                                            justifyItems: 'center',
                                                            gap: 1,
                                                            elements: [{
                                                                    type: FormItemTypes.Typography,
                                                                    name: 'primary-number',
                                                                    columnSize: true,
                                                                    fontSize: "sm",
                                                                    color: 'text.secondary',
                                                                    fontWeight: 'medium',
                                                                    id: 'customer-mobile-no',
                                                                    valueGetter: function (formData) {
                                                                        var _crud$vehicleHistoryK5, _crud$vehicleHistoryK6;
                                                                        return "".concat((_crud$vehicleHistoryK5 = (_crud$vehicleHistoryK6 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK6 === void 0 || (_crud$vehicleHistoryK6 = _crud$vehicleHistoryK6.data) === null || _crud$vehicleHistoryK6 === void 0 || (_crud$vehicleHistoryK6 = _crud$vehicleHistoryK6.PersonContactPoint[1]) === null || _crud$vehicleHistoryK6 === void 0 ? void 0 : _crud$vehicleHistoryK6.MobileNumber) !== null && _crud$vehicleHistoryK5 !== void 0 ? _crud$vehicleHistoryK5 : '-');
                                                                    }
                                                                }, {
                                                                    type: FormItemTypes.Icon,
                                                                    name: 'verified-icon',
                                                                    children: ((_crud$vehicleHistoryK7 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK7 === void 0 || (_crud$vehicleHistoryK7 = _crud$vehicleHistoryK7.data) === null || _crud$vehicleHistoryK7 === void 0 || (_crud$vehicleHistoryK7 = _crud$vehicleHistoryK7.PersonContactPoint[1]) === null || _crud$vehicleHistoryK7 === void 0 ? void 0 : _crud$vehicleHistoryK7.IsMobileVerified) == true ? /*#__PURE__*/ React.createElement(VerifiedIcon, {
                                                                        height: 15,
                                                                        width: 15
                                                                    }) : undefined,
                                                                    columnSize: 0,
                                                                    sx: {
                                                                        color: 'info.500',
                                                                        p: 0,
                                                                        mt: '5px',
                                                                        alignItems: 'center',
                                                                        marginBottom: '-10px'
                                                                    }
                                                                }]
                                                        }]
                                                }]
                                        } : null, isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: 'customer-details-card',
                                            columnSize: 12,
                                            contentProps: {
                                                spacing: 0,
                                                gap: '8px'
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    columnGap: 1,
                                                    rowGap: 1,
                                                    elements: [{
                                                            type: FormItemTypes.Avatar,
                                                            name: 'vh-profile-icon',
                                                            columnSize: 0
                                                        }, {
                                                            type: FormItemTypes.ContainerItem,
                                                            name: '',
                                                            columnSize: true,
                                                            spacing: 0,
                                                            elements: [{
                                                                    type: FormItemTypes.Typography,
                                                                    name: 'vh-customer-name',
                                                                    value: "".concat((_crud$vehicleHistoryK8 = (_crud$vehicleHistoryK9 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK9 === void 0 || (_crud$vehicleHistoryK9 = _crud$vehicleHistoryK9.data) === null || _crud$vehicleHistoryK9 === void 0 || (_crud$vehicleHistoryK9 = _crud$vehicleHistoryK9.Person) === null || _crud$vehicleHistoryK9 === void 0 ? void 0 : _crud$vehicleHistoryK9.GivenName) !== null && _crud$vehicleHistoryK8 !== void 0 ? _crud$vehicleHistoryK8 : '-', " ").concat((_crud$vehicleHistoryK10 = (_crud$vehicleHistoryK11 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK11 === void 0 || (_crud$vehicleHistoryK11 = _crud$vehicleHistoryK11.data) === null || _crud$vehicleHistoryK11 === void 0 || (_crud$vehicleHistoryK11 = _crud$vehicleHistoryK11.Person) === null || _crud$vehicleHistoryK11 === void 0 ? void 0 : _crud$vehicleHistoryK11.FamilyName) !== null && _crud$vehicleHistoryK10 !== void 0 ? _crud$vehicleHistoryK10 : ' '),
                                                                    columnSize: 12,
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    fontWeight: 'medium',
                                                                    fontSize: 'base',
                                                                    color: 'text.primary'
                                                                }, {
                                                                    type: FormItemTypes.ContainerItem,
                                                                    name: '',
                                                                    columnSize: 12,
                                                                    spacing: 0,
                                                                    elements: [{
                                                                            type: FormItemTypes.ContainerItem,
                                                                            name: '',
                                                                            columnSize: 0,
                                                                            spacing: 0,
                                                                            elements: [{
                                                                                    type: FormItemTypes.Typography,
                                                                                    name: 'vh-primary-number',
                                                                                    // value: ,
                                                                                    containerProps: {
                                                                                        spacing: 0
                                                                                    },
                                                                                    columnSize: 0,
                                                                                    fontSize: "sm",
                                                                                    color: 'text.tertiary',
                                                                                    fontWeight: 'medium',
                                                                                    valueGetter: function (formValues, field) {
                                                                                        var _crud$vehicleHistoryK12, _crud$vehicleHistoryK13;
                                                                                        return "".concat((_crud$vehicleHistoryK12 = (_crud$vehicleHistoryK13 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK13 === void 0 || (_crud$vehicleHistoryK13 = _crud$vehicleHistoryK13.data) === null || _crud$vehicleHistoryK13 === void 0 || (_crud$vehicleHistoryK13 = _crud$vehicleHistoryK13.PersonContactPoint[1]) === null || _crud$vehicleHistoryK13 === void 0 ? void 0 : _crud$vehicleHistoryK13.MobileNumber) !== null && _crud$vehicleHistoryK12 !== void 0 ? _crud$vehicleHistoryK12 : '-');
                                                                                    }
                                                                                }, {
                                                                                    type: FormItemTypes.Icon,
                                                                                    name: '',
                                                                                    children: ((_crud$vehicleHistoryK14 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK14 === void 0 || (_crud$vehicleHistoryK14 = _crud$vehicleHistoryK14.data) === null || _crud$vehicleHistoryK14 === void 0 || (_crud$vehicleHistoryK14 = _crud$vehicleHistoryK14.PersonContactPoint[1]) === null || _crud$vehicleHistoryK14 === void 0 ? void 0 : _crud$vehicleHistoryK14.IsMobileVerified) == true ? /*#__PURE__*/ React.createElement(VerifiedIcon, {
                                                                                        height: 18,
                                                                                        width: 18
                                                                                    }) : undefined,
                                                                                    columnSize: 0,
                                                                                    sx: {
                                                                                        color: info[500],
                                                                                        p: 0,
                                                                                        mt: '2px',
                                                                                        pb: '6px',
                                                                                        alignItems: 'center',
                                                                                        display: ((_crud$vehicleHistoryK15 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK15 === void 0 || (_crud$vehicleHistoryK15 = _crud$vehicleHistoryK15.data) === null || _crud$vehicleHistoryK15 === void 0 || (_crud$vehicleHistoryK15 = _crud$vehicleHistoryK15.PersonContactPoint[1]) === null || _crud$vehicleHistoryK15 === void 0 ? void 0 : _crud$vehicleHistoryK15.IsMobileVerified) == true ? 'inline-flex' : 'none'
                                                                                    }
                                                                                }, {
                                                                                    type: FormItemTypes.Divider,
                                                                                    name: 'name',
                                                                                    variant: 'fullWidth',
                                                                                    orientation: 'vertical',
                                                                                    columnSize: 0,
                                                                                    setFieldProps: function (formValues) {
                                                                                        var _formValues$data;
                                                                                        var mobileNo = formValues === null || formValues === void 0 || (_formValues$data = formValues.data) === null || _formValues$data === void 0 || (_formValues$data = _formValues$data.PersonContact) === null || _formValues$data === void 0 || (_formValues$data = _formValues$data[0]) === null || _formValues$data === void 0 ? void 0 : _formValues$data.MobileNumber;
                                                                                        var IsdDisplay = !!mobileNo && mobileNo !== '0000000000';
                                                                                        return {
                                                                                            type: FormItemTypes.Divider,
                                                                                            sx: {
                                                                                                display: IsdDisplay ? 'inline-flex' : 'none',
                                                                                                height: '13px',
                                                                                                mx: '3px'
                                                                                            }
                                                                                        };
                                                                                    }
                                                                                }, {
                                                                                    type: FormItemTypes.ContainerItem,
                                                                                    name: 'vh-secondary-number-section',
                                                                                    columnSize: true,
                                                                                    display: 'flex',
                                                                                    flexDirection: 'row',
                                                                                    spacing: 0,
                                                                                    gap: '0px',
                                                                                    elements: [{
                                                                                            type: FormItemTypes.Typography,
                                                                                            name: 'vh-secondary-number',
                                                                                            columnSize: 0,
                                                                                            fontSize: 'sm',
                                                                                            color: 'text.tertiary',
                                                                                            fontWeight: 'medium',
                                                                                            valueGetter: function (formValues, field) {
                                                                                                var _crud$vehicleHistoryK16;
                                                                                                var mobileNumber = (_crud$vehicleHistoryK16 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK16 === void 0 || (_crud$vehicleHistoryK16 = _crud$vehicleHistoryK16.data) === null || _crud$vehicleHistoryK16 === void 0 || (_crud$vehicleHistoryK16 = _crud$vehicleHistoryK16.PersonContactPoint) === null || _crud$vehicleHistoryK16 === void 0 || (_crud$vehicleHistoryK16 = _crud$vehicleHistoryK16[0]) === null || _crud$vehicleHistoryK16 === void 0 ? void 0 : _crud$vehicleHistoryK16.MobileNumber;
                                                                                                return mobileNumber !== '0000000000' ? mobileNumber : '';
                                                                                            }
                                                                                        }, {
                                                                                            type: FormItemTypes.Icon,
                                                                                            name: '',
                                                                                            children: (function (_crud$vehicleHistoryK17) {
                                                                                                var personContact = (_crud$vehicleHistoryK17 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK17 === void 0 || (_crud$vehicleHistoryK17 = _crud$vehicleHistoryK17.data) === null || _crud$vehicleHistoryK17 === void 0 || (_crud$vehicleHistoryK17 = _crud$vehicleHistoryK17.PersonContactPoint) === null || _crud$vehicleHistoryK17 === void 0 ? void 0 : _crud$vehicleHistoryK17[0];
                                                                                                var mobileNumber = personContact === null || personContact === void 0 ? void 0 : personContact.MobileNumber;
                                                                                                var isVerified = personContact === null || personContact === void 0 ? void 0 : personContact.IsMobileVerified;
                                                                                                return mobileNumber && mobileNumber !== '0000000000' && isVerified === true ? /*#__PURE__*/ React.createElement(VerifiedIcon, {
                                                                                                    height: 18,
                                                                                                    width: 18
                                                                                                }) : undefined;
                                                                                            })(),
                                                                                            columnSize: 0,
                                                                                            sx: {
                                                                                                color: info[500],
                                                                                                p: 0,
                                                                                                mt: '2px',
                                                                                                pb: '6px',
                                                                                                alignItems: 'center'
                                                                                            }
                                                                                        }]
                                                                                }]
                                                                        }]
                                                                }]
                                                        }]
                                                }, {
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    spacing: 0,
                                                    columnSize: 12,
                                                    gap: '8px',
                                                    p: 0,
                                                    elements: [{
                                                            type: FormItemTypes.ContainerItem,
                                                            name: 'customer-email',
                                                            columnSize: 12,
                                                            spacing: 0,
                                                            columnGap: 1,
                                                            alignItems: 'center',
                                                            elements: [{
                                                                    type: FormItemTypes.IconButton,
                                                                    name: '',
                                                                    columnSize: 0,
                                                                    // element: () => <MailIcon color='secondary.500' width={16} height={16} />,
                                                                    children: /*#__PURE__*/ React.createElement(MailIcon, {
                                                                        width: 16,
                                                                        height: 16
                                                                    }),
                                                                    color: 'secondary',
                                                                    sx: {
                                                                        color: 'secondary.500',
                                                                        p: 0
                                                                    }
                                                                }, {
                                                                    type: FormItemTypes.Typography,
                                                                    name: 'Email',
                                                                    value: (_crud$vehicleHistoryK18 = (_crud$vehicleHistoryK19 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK19 === void 0 || (_crud$vehicleHistoryK19 = _crud$vehicleHistoryK19.data) === null || _crud$vehicleHistoryK19 === void 0 || (_crud$vehicleHistoryK19 = _crud$vehicleHistoryK19.PersonContactPoint[1]) === null || _crud$vehicleHistoryK19 === void 0 ? void 0 : _crud$vehicleHistoryK19.Email) !== null && _crud$vehicleHistoryK18 !== void 0 ? _crud$vehicleHistoryK18 : '-',
                                                                    columnSize: true,
                                                                    color: 'text.tertiary',
                                                                    fontSize: 'sm',
                                                                    fontWeight: 'normal',
                                                                    // textAlign:'center',
                                                                    containerProps: {
                                                                        mt: '2px'
                                                                    }
                                                                }]
                                                        }, {
                                                            type: FormItemTypes.Box,
                                                            name: '',
                                                            display: 'flex',
                                                            columnSize: 12,
                                                            gap: '8px',
                                                            alignItems: 'start',
                                                            elements: [{
                                                                    type: FormItemTypes.IconButton,
                                                                    name: '',
                                                                    children: /*#__PURE__*/ React.createElement(LocationIcon, {
                                                                        height: 16,
                                                                        width: 16
                                                                    }),
                                                                    columnSize: 0,
                                                                    sx: {
                                                                        paddingInline: 0
                                                                    }
                                                                }, {
                                                                    type: FormItemTypes.Typography,
                                                                    name: 'Address',
                                                                    columnSize: true,
                                                                    value: "".concat((_crud$vehicleHistoryK20 = (_crud$vehicleHistoryK21 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK21 === void 0 || (_crud$vehicleHistoryK21 = _crud$vehicleHistoryK21.data) === null || _crud$vehicleHistoryK21 === void 0 || (_crud$vehicleHistoryK21 = _crud$vehicleHistoryK21.Address[0]) === null || _crud$vehicleHistoryK21 === void 0 ? void 0 : _crud$vehicleHistoryK21.Address1) !== null && _crud$vehicleHistoryK20 !== void 0 ? _crud$vehicleHistoryK20 : '-', " ").concat((_crud$vehicleHistoryK22 = (_crud$vehicleHistoryK23 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK23 === void 0 || (_crud$vehicleHistoryK23 = _crud$vehicleHistoryK23.data) === null || _crud$vehicleHistoryK23 === void 0 || (_crud$vehicleHistoryK23 = _crud$vehicleHistoryK23.Address[0]) === null || _crud$vehicleHistoryK23 === void 0 ? void 0 : _crud$vehicleHistoryK23.Address2) !== null && _crud$vehicleHistoryK22 !== void 0 ? _crud$vehicleHistoryK22 : ' ', " PIN:  ").concat((_crud$vehicleHistoryK24 = (_crud$vehicleHistoryK25 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK25 === void 0 || (_crud$vehicleHistoryK25 = _crud$vehicleHistoryK25.data) === null || _crud$vehicleHistoryK25 === void 0 || (_crud$vehicleHistoryK25 = _crud$vehicleHistoryK25.Address[0]) === null || _crud$vehicleHistoryK25 === void 0 ? void 0 : _crud$vehicleHistoryK25.Zip) !== null && _crud$vehicleHistoryK24 !== void 0 ? _crud$vehicleHistoryK24 : '-'),
                                                                    color: 'text.tertiary',
                                                                    fontSize: 'sm',
                                                                    fontWeight: 'normal',
                                                                    marginTop: '2px',
                                                                    paddingRight: '12px'
                                                                }]
                                                        }]
                                                }]
                                        } : null]
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: isRightDrawer ? 6 : 4,
                                    lg: isRightDrawer ? 6 : 4,
                                    xl: isRightDrawer ? 6 : 3,
                                    spacing: 1,
                                    elements: [{
                                            type: FormItemTypes.ContainerItem,
                                            name: 'vehicleDtails',
                                            justifyContent: 'space-between',
                                            columnSize: 12,
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    children: 'Vehicle details',
                                                    fontSize: 'sm',
                                                    fontWeight: 'medium',
                                                    color: 'text.secondary',
                                                    columnSize: 0
                                                }]
                                        }, !isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: 'vehicle-detail-card',
                                            columnSize: 12,
                                            contentProps: {
                                                justifyContent: "space-between",
                                                spacing: 0
                                            },
                                            sx: {
                                                padding: {
                                                    xs: "14px 12px"
                                                }
                                            },
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: 'vehicle-registration-no',
                                                    // value: `${crud[vehicleHistoryKeys.InstallBaseListKey]?.data?.InstallBase[0]?.RegistrationNo ?? '-'}`,
                                                    columnSize: 0,
                                                    fontWeight: 'medium',
                                                    fontSize: 'base',
                                                    color: 'text.primary',
                                                    valueGetter: function (formData) {
                                                        var _crud$vehicleHistoryK26, _crud$vehicleHistoryK27;
                                                        return "".concat((_crud$vehicleHistoryK26 = (_crud$vehicleHistoryK27 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK27 === void 0 || (_crud$vehicleHistoryK27 = _crud$vehicleHistoryK27.data) === null || _crud$vehicleHistoryK27 === void 0 || (_crud$vehicleHistoryK27 = _crud$vehicleHistoryK27.InstallBase[0]) === null || _crud$vehicleHistoryK27 === void 0 ? void 0 : _crud$vehicleHistoryK27.RegistrationNo) !== null && _crud$vehicleHistoryK26 !== void 0 ? _crud$vehicleHistoryK26 : '-');
                                                    }
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: 'vehicle-model-name',
                                                    columnSize: 0,
                                                    fontSize: "sm",
                                                    color: 'text.secondary',
                                                    fontWeight: 'normal',
                                                    valueGetter: function (formData) {
                                                        var _crud$vehicleHistoryK28, _crud$vehicleHistoryK29, _crud$vehicleHistoryK30, _crud$vehicleHistoryK31;
                                                        var productName = (_crud$vehicleHistoryK28 = (_crud$vehicleHistoryK29 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK29 === void 0 || (_crud$vehicleHistoryK29 = _crud$vehicleHistoryK29.data) === null || _crud$vehicleHistoryK29 === void 0 || (_crud$vehicleHistoryK29 = _crud$vehicleHistoryK29.InstallBase[0]) === null || _crud$vehicleHistoryK29 === void 0 ? void 0 : _crud$vehicleHistoryK29.ProductName) !== null && _crud$vehicleHistoryK28 !== void 0 ? _crud$vehicleHistoryK28 : '-';
                                                        var skuCode = (_crud$vehicleHistoryK30 = (_crud$vehicleHistoryK31 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK31 === void 0 || (_crud$vehicleHistoryK31 = _crud$vehicleHistoryK31.data) === null || _crud$vehicleHistoryK31 === void 0 || (_crud$vehicleHistoryK31 = _crud$vehicleHistoryK31.InstallBase[0]) === null || _crud$vehicleHistoryK31 === void 0 ? void 0 : _crud$vehicleHistoryK31.SKUCode) !== null && _crud$vehicleHistoryK30 !== void 0 ? _crud$vehicleHistoryK30 : '';
                                                        var merged = "".concat(productName, " (").concat(skuCode, ")");
                                                        return merged.length > 20 ? merged.slice(0, 20) + '...' : merged;
                                                    },
                                                    labelTypographyProps: {
                                                        mb: 0,
                                                        noWrap: true,
                                                        fontWeight: 'medium',
                                                        fontSize: 'sm',
                                                        textOverflow: 'unset',
                                                        minWidth: '40%'
                                                    },
                                                    sx: {
                                                        textAlign: 'right'
                                                    }
                                                }]
                                        } : null, isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: 'vehicle-detail-card',
                                            columnSize: 12,
                                            // sx: { p: '12px' },
                                            contentProps: {
                                                spacing: 0,
                                                rowGap: 1
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: 'vehicle-registration-no',
                                                            // value: `${crud[vehicleHistoryKeys.InstallBaseListKey]?.data?.InstallBase[0]?.RegistrationNo ?? '-'}`,
                                                            columnSize: 12,
                                                            fontWeight: 'medium',
                                                            fontSize: 'base',
                                                            color: 'text.primary',
                                                            valueGetter: function (formData) {
                                                                var _crud$vehicleHistoryK32, _crud$vehicleHistoryK33;
                                                                return "".concat((_crud$vehicleHistoryK32 = (_crud$vehicleHistoryK33 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK33 === void 0 || (_crud$vehicleHistoryK33 = _crud$vehicleHistoryK33.data) === null || _crud$vehicleHistoryK33 === void 0 || (_crud$vehicleHistoryK33 = _crud$vehicleHistoryK33.InstallBase[0]) === null || _crud$vehicleHistoryK33 === void 0 ? void 0 : _crud$vehicleHistoryK33.RegistrationNo) !== null && _crud$vehicleHistoryK32 !== void 0 ? _crud$vehicleHistoryK32 : '-');
                                                            }
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'ProductName',
                                                            // value: `${crud[vehicleHistoryKeys.InstallBaseListKey]?.data?.InstallBase[0]?.ProductName ?? '-'} (${crud[vehicleHistoryKeys.InstallBaseListKey]?.data?.InstallBase[0]?.SKUCode ?? ''})`,
                                                            columnSize: 12,
                                                            fontSize: "sm",
                                                            color: 'text.secondary',
                                                            fontWeight: 'normal',
                                                            valueGetter: function (formData) {
                                                                var _crud$vehicleHistoryK34, _crud$vehicleHistoryK35, _crud$vehicleHistoryK36, _crud$vehicleHistoryK37;
                                                                return "".concat((_crud$vehicleHistoryK34 = (_crud$vehicleHistoryK35 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK35 === void 0 || (_crud$vehicleHistoryK35 = _crud$vehicleHistoryK35.data) === null || _crud$vehicleHistoryK35 === void 0 || (_crud$vehicleHistoryK35 = _crud$vehicleHistoryK35.InstallBase[0]) === null || _crud$vehicleHistoryK35 === void 0 ? void 0 : _crud$vehicleHistoryK35.ProductName) !== null && _crud$vehicleHistoryK34 !== void 0 ? _crud$vehicleHistoryK34 : '-', " (").concat((_crud$vehicleHistoryK36 = (_crud$vehicleHistoryK37 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK37 === void 0 || (_crud$vehicleHistoryK37 = _crud$vehicleHistoryK37.data) === null || _crud$vehicleHistoryK37 === void 0 || (_crud$vehicleHistoryK37 = _crud$vehicleHistoryK37.InstallBase[0]) === null || _crud$vehicleHistoryK37 === void 0 ? void 0 : _crud$vehicleHistoryK37.SKUCode) !== null && _crud$vehicleHistoryK36 !== void 0 ? _crud$vehicleHistoryK36 : '', ")");
                                                            }
                                                        }]
                                                }, {
                                                    type: FormItemTypes.ContainerItem,
                                                    name: 'Vehicle details',
                                                    spacing: 0,
                                                    columnSize: 12,
                                                    p: '8px 12px',
                                                    gap: '4px',
                                                    sx: {
                                                        bgcolor: "secondary.50",
                                                        border: "none",
                                                        borderRadius: '8px'
                                                    },
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: 'EngineNo',
                                                            label: 'Engine no:',
                                                            value: "".concat((_crud$vehicleHistoryK38 = (_crud$vehicleHistoryK39 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK39 === void 0 || (_crud$vehicleHistoryK39 = _crud$vehicleHistoryK39.data) === null || _crud$vehicleHistoryK39 === void 0 || (_crud$vehicleHistoryK39 = _crud$vehicleHistoryK39.InstallBase[0]) === null || _crud$vehicleHistoryK39 === void 0 ? void 0 : _crud$vehicleHistoryK39.EngineNo) !== null && _crud$vehicleHistoryK38 !== void 0 ? _crud$vehicleHistoryK38 : '-'),
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'normal',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'normal',
                                                            fontSize: 'sm',
                                                            color: 'text.primary',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'VinNo',
                                                            label: 'Chassis no:',
                                                            value: "".concat((_crud$vehicleHistoryK40 = (_crud$vehicleHistoryK41 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK41 === void 0 || (_crud$vehicleHistoryK41 = _crud$vehicleHistoryK41.data) === null || _crud$vehicleHistoryK41 === void 0 || (_crud$vehicleHistoryK41 = _crud$vehicleHistoryK41.InstallBase[0]) === null || _crud$vehicleHistoryK41 === void 0 ? void 0 : _crud$vehicleHistoryK41.VinNo) !== null && _crud$vehicleHistoryK40 !== void 0 ? _crud$vehicleHistoryK40 : '-'),
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'normal',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'normal',
                                                            fontSize: 'sm',
                                                            color: 'text.primary',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'SalesInvoiceDate',
                                                            label: 'Date of sale:',
                                                            value: (_crud$vehicleHistoryK42 = crud[vehicleHistoryKeys.InstallBaseListKey]) !== null && _crud$vehicleHistoryK42 !== void 0 && (_crud$vehicleHistoryK42 = _crud$vehicleHistoryK42.data) !== null && _crud$vehicleHistoryK42 !== void 0 && _crud$vehicleHistoryK42.InstallBase[0].SalesInvoiceDate ? dayjs((_crud$vehicleHistoryK43 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK43 === void 0 || (_crud$vehicleHistoryK43 = _crud$vehicleHistoryK43.data) === null || _crud$vehicleHistoryK43 === void 0 ? void 0 : _crud$vehicleHistoryK43.InstallBase[0].SalesInvoiceDate).format('DD MMM, YYYY') : '-',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'normal',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'normal',
                                                            fontSize: 'sm',
                                                            color: 'text.primary',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'NPS',
                                                            label: 'NPS:',
                                                            columnSize: 12,
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                fontWeight: 'normal'
                                                            },
                                                            containerProps: {
                                                                display: 'flex',
                                                                direction: 'row',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center'
                                                            },
                                                            setFieldProps: function (formValues) {
                                                                var _formValues$NPSRespon, _formValues$NPSRespon2;
                                                                var rating = formValues === null || formValues === void 0 || (_formValues$NPSRespon = formValues.NPSResponse) === null || _formValues$NPSRespon === void 0 || (_formValues$NPSRespon = _formValues$NPSRespon[0]) === null || _formValues$NPSRespon === void 0 ? void 0 : _formValues$NPSRespon.AnswerRating;
                                                                return {
                                                                    children: (formValues === null || formValues === void 0 || (_formValues$NPSRespon2 = formValues.NPSResponse) === null || _formValues$NPSRespon2 === void 0 ? void 0 : _formValues$NPSRespon2.length) > 0 && rating && (SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName) === "MC" ? /*#__PURE__*/ React.createElement(NpsChip, {
                                                                        rating: rating
                                                                    }) : '-'
                                                                };
                                                            }
                                                        }]
                                                }]
                                        } : null]
                                }]
                        }]
                }]
        })];
    var serviceHistory = __spreadArray(__spreadArray([], BasicAndVehicleDetails, true), [isMobile ? _objectSpread(_objectSpread({
            type: FormItemTypes.Accordian,
            name: 'serviceDetails',
            label: '',
            value: null,
            containerProps: {
                spacing: 0
            },
            detailPanelProps: {
                p: 2,
                pt: 0,
                spacing: 0,
                rowGap: 2
            },
            summaryProps: {
                sx: {
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex'
                }
            }
        }, selectedVinNo ? {} : {
            setFieldProps: function (state) { return ({
                type: FormItemTypes.Accordian,
                sx: {
                    display: state !== null && state !== void 0 && state.success ? undefined : 'none',
                    bgcolor: 'white',
                    borderLeft: 'none',
                    borderRight: 'none',
                    borderRadius: 0
                }
            }); }
        }), {}, {
            summary: [{
                    type: FormItemTypes.Typography,
                    name: 'JobCardDetail',
                    label: '',
                    value: null,
                    children: 'Job Cards',
                    columnSize: 0,
                    fontWeight: 'strong',
                    fontSize: 'lg'
                }, {
                    type: FormItemTypes.Chip,
                    name: 'job-card-details-count',
                    label: ((_crud$vehicleHistoryK44 = crud[vehicleHistoryKeys.SeviceHistoryKey]) === null || _crud$vehicleHistoryK44 === void 0 || (_crud$vehicleHistoryK44 = _crud$vehicleHistoryK44.data) === null || _crud$vehicleHistoryK44 === void 0 ? void 0 : _crud$vehicleHistoryK44.ServiceDetails.length) || 0,
                    columnSize: 0,
                    size: 'small',
                    variant: 'outlined',
                    color: 'info',
                    sx: {
                        ml: '8px'
                    }
                }],
            elements: [{
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 12,
                    variant: 'fullWidth'
                }, {
                    type: FormItemTypes.List,
                    name: 'ServiceDetails',
                    columnSize: 12,
                    variant: 'compact',
                    value: null,
                    // value: selectedVinNo ? crud[vehicleHistoryKeys.SeviceHistoryKey]?.data?.ServiceDetails : null,
                    disableCheckboxSelection: true,
                    sx: {},
                    cellStyles: {
                        bgcolor: "secondary.50"
                    },
                    columns: [{
                            field: '',
                            flex: 1,
                            renderCell: function (params) {
                                var _params$row;
                                return /*#__PURE__*/ React.createElement(Stack, {
                                    direction: 'row',
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: '20px',
                                    width: "100%"
                                }, /*#__PURE__*/ React.createElement(Typography, {
                                    id: "job-card-dealer-name",
                                    fontWeight: "medium",
                                    sx: {
                                        textWrap: 'wrap',
                                        maxWidth: '60%'
                                    }
                                }, params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.DealerName), /*#__PURE__*/ React.createElement(Button, {
                                    id: "view",
                                    children: "View",
                                    variant: "text",
                                    size: "small",
                                    color: "primary",
                                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        var historyDrawer;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Drawer',
                                                        Component: ViewServiceHistory,
                                                        containerProps: {
                                                            anchor: 'bottom',
                                                            PaperProps: {
                                                                sx: {
                                                                    borderRadius: '8px 8px 0 0',
                                                                    height: '90%'
                                                                }
                                                            }
                                                        },
                                                        componentProps: {
                                                            data: params === null || params === void 0 ? void 0 : params.row,
                                                            isFromQuickLink: selectedVinNo ? true : false
                                                        }
                                                    }))];
                                                case 1:
                                                    historyDrawer = _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }
                                }));
                            }
                        }],
                    elements: JobCardDetailsMobile
                }],
            columnSize: 12
        }) : _objectSpread({
            type: FormItemTypes.Custom,
            name: "ServiceDetails",
            element: JobCardDetailsCatalogView,
            columnSize: 12
        }, selectedVinNo ? {} : {
            setFieldProps: function (state) {
                return {
                    type: FormItemTypes.Custom,
                    hidden: state.success && state !== null && state !== void 0 && state.Value ? false : true
                };
            }
        })], false);
    var contractHistory = [
        _objectSpread(_objectSpread({
            type: FormItemTypes.CardComponent,
            name: '',
            value: null,
            columnSize: 12,
            contentProps: {
                spacing: 0,
                gap: 2
            },
            sx: {
                flexDirection: 'row'
            }
        }, selectedVinNo ? {} : {
            setFieldProps: function (state) { return ({
                type: FormItemTypes.CardComponent,
                sx: {
                    display: state !== null && state !== void 0 && state.success && state !== null && state !== void 0 && state.Value ? undefined : 'none'
                }
            }); }
        }), {}, {
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    width: 'auto',
                    p: 0,
                    sx: {
                        overflowX: 'auto',
                        overflowY: 'visible',
                        flexWrap: 'nowrap',
                        width: '100%',
                        scrollbarWidth: 'none'
                    },
                    position: 'static',
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 0,
                            spacing: 0,
                            width: 'auto',
                            flexWrap: 'nowrap',
                            gap: '8px',
                            padding: '4px',
                            bgcolor: 'secondary.100',
                            border: '1px solid',
                            borderColor: 'secondary.200',
                            borderRadius: '8px',
                            elements: [{
                                    type: FormItemTypes.Button,
                                    label: '',
                                    name: 'Active',
                                    columnSize: 0,
                                    variant: 'text',
                                    color: 'secondary',
                                    size: 'small',
                                    setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                        var selectedStatus, filteredContracts;
                                        return __generator(this, function (_a) {
                                            selectedStatus = field.name;
                                            filteredContracts = filterContractsByStatus((state === null || state === void 0 ? void 0 : state.IBContractDetails) || [], selectedStatus);
                                            return [2 /*return*/, {
                                                    SelectedButton: field.name,
                                                    NewIBContractDetails: filteredContracts
                                                }];
                                        });
                                    }); },
                                    setFieldProps: function (state, value) {
                                        var _state$statusCounts$A, _state$statusCounts;
                                        console.log('state', state);
                                        return {
                                            type: FormItemTypes.Button,
                                            variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                            color: 'secondary',
                                            sx: {
                                                fontWeight: 'strong',
                                                color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100",
                                                '&:hover': {
                                                    bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                                }
                                            },
                                            children: ['Active', /*#__PURE__*/ React.createElement(Chip, {
                                                    variant: "filled",
                                                    size: "small",
                                                    color: "secondary",
                                                    sx: {
                                                        fontWeight: 'medium',
                                                        color: 'text.primary'
                                                    },
                                                    label: (_state$statusCounts$A = state === null || state === void 0 || (_state$statusCounts = state.statusCounts) === null || _state$statusCounts === void 0 ? void 0 : _state$statusCounts.Active) !== null && _state$statusCounts$A !== void 0 ? _state$statusCounts$A : 0
                                                })]
                                        };
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    label: '',
                                    name: 'Availed',
                                    columnSize: 0,
                                    variant: 'text',
                                    color: 'secondary',
                                    size: 'small',
                                    fullWidth: true,
                                    setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                        var selectedStatus, filteredContracts;
                                        return __generator(this, function (_a) {
                                            selectedStatus = field.name;
                                            filteredContracts = filterContractsByStatus((state === null || state === void 0 ? void 0 : state.IBContractDetails) || [], selectedStatus);
                                            return [2 /*return*/, {
                                                    SelectedButton: field.name,
                                                    NewIBContractDetails: filteredContracts
                                                }];
                                        });
                                    }); },
                                    setFieldProps: function (state, value) {
                                        var _state$statusCounts$A2, _state$statusCounts2;
                                        return {
                                            type: FormItemTypes.Button,
                                            variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                            color: 'secondary',
                                            sx: {
                                                fontWeight: 'strong',
                                                color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100",
                                                '&:hover': {
                                                    bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                                }
                                            },
                                            children: ['Availed', /*#__PURE__*/ React.createElement(Chip, {
                                                    variant: "filled",
                                                    size: "small",
                                                    color: "secondary",
                                                    sx: {
                                                        fontWeight: 'medium',
                                                        color: 'text.primary'
                                                    },
                                                    label: (_state$statusCounts$A2 = state === null || state === void 0 || (_state$statusCounts2 = state.statusCounts) === null || _state$statusCounts2 === void 0 ? void 0 : _state$statusCounts2.Availed) !== null && _state$statusCounts$A2 !== void 0 ? _state$statusCounts$A2 : 0
                                                })]
                                        };
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    label: '',
                                    name: 'Expired',
                                    columnSize: 0,
                                    variant: 'text',
                                    color: 'secondary',
                                    size: 'small',
                                    fullWidth: true,
                                    setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                        var selectedStatus, filteredContracts;
                                        return __generator(this, function (_a) {
                                            selectedStatus = field.name;
                                            filteredContracts = filterContractsByStatus((state === null || state === void 0 ? void 0 : state.IBContractDetails) || [], selectedStatus);
                                            return [2 /*return*/, {
                                                    SelectedButton: field.name,
                                                    NewIBContractDetails: filteredContracts
                                                }];
                                        });
                                    }); },
                                    setFieldProps: function (state, value) {
                                        var _state$statusCounts$E, _state$statusCounts3;
                                        return {
                                            type: FormItemTypes.Button,
                                            variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                            color: 'secondary',
                                            sx: {
                                                fontWeight: 'strong',
                                                color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100",
                                                '&:hover': {
                                                    bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                                }
                                            },
                                            children: ['Expired', /*#__PURE__*/ React.createElement(Chip, {
                                                    variant: "filled",
                                                    size: "small",
                                                    color: "secondary",
                                                    sx: {
                                                        fontWeight: 'medium',
                                                        color: 'text.primary'
                                                    },
                                                    label: (_state$statusCounts$E = state === null || state === void 0 || (_state$statusCounts3 = state.statusCounts) === null || _state$statusCounts3 === void 0 ? void 0 : _state$statusCounts3.Expired) !== null && _state$statusCounts$E !== void 0 ? _state$statusCounts$E : 0
                                                })]
                                        };
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.Iterator,
                    name: 'NewIBContractDetails',
                    columnSize: 12,
                    containerProps: {
                        container: true,
                        spacing: 2
                    },
                    gridItemProps: {
                        xs: 12,
                        sm: 6,
                        md: selectedVinNo ? 6 : 4,
                        lg: selectedVinNo ? 6 : commonState.isMenuOpen ? 4 : 3
                    },
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            border: '1px solid',
                            borderColor: 'secondary.200',
                            borderRadius: '12px',
                            padding: 2,
                            gap: 2,
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    columnSize: 12,
                                    spacing: 0,
                                    display: 'flex',
                                    elements: [{
                                            type: FormItemTypes.Box,
                                            name: '',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            columnSize: 12,
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: 'ItemName',
                                                    value: null,
                                                    columnSize: true,
                                                    fontSize: 'sm',
                                                    fontWeight: 'medium',
                                                    color: 'text.secondary'
                                                }, {
                                                    type: FormItemTypes.Chip,
                                                    name: 'status',
                                                    size: 'small',
                                                    columnSize: 0,
                                                    sx: {
                                                        borderRadius: '6px',
                                                        display: 'flex'
                                                    },
                                                    setFieldProps: function (formValues, currValue) {
                                                        var _getStatusColor;
                                                        var effectiveToDate = new Date(formValues === null || formValues === void 0 ? void 0 : formValues.EffectiveTo);
                                                        var currentDate = new Date();
                                                        var status = currentDate > effectiveToDate ? (formValues === null || formValues === void 0 ? void 0 : formValues.IsAvailed) === "Yes" ? "Availed" : "Expired" : (formValues === null || formValues === void 0 ? void 0 : formValues.IsAvailed) === "Yes" ? "Availed" : "Active";
                                                        return {
                                                            type: FormItemTypes.Chip,
                                                            color: (_getStatusColor = getStatusColor(status)) === null || _getStatusColor === void 0 ? void 0 : _getStatusColor.color,
                                                            label: status
                                                        };
                                                    }
                                                }]
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'ContractTypeName',
                                            value: null,
                                            columnSize: 12,
                                            fontSize: 'lg',
                                            fontWeight: 'medium',
                                            color: 'text.primary'
                                        }]
                                },
                                // {
                                //     type: FormItemTypes.CardComponent,
                                //     name: 'Vehicle details',
                                //     containerProps: { spacing: 0, p: 0 },
                                //     columnSize: 12,
                                //     sx: {
                                //         bgcolor: "secondary.50",
                                //         border: "none",
                                //         // px: 1.5,
                                //         // py: 1
                                //     },
                                //     contentProps: { spacing: 0, p: 0 },
                                {
                                    type: FormItemTypes.ContainerItem,
                                    name: 'Vehicle details',
                                    columnSize: 12,
                                    bgcolor: "secondary.50",
                                    spacing: 0,
                                    p: '8px',
                                    gap: '4px',
                                    borderRadius: '8px',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'EffectiveFROM',
                                            label: 'Effective from date:',
                                            value: null,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                color: 'secondary.600'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            color: 'text.primary',
                                            columnSize: 12,
                                            textAlign: 'end',
                                            valueGetter: function (formData) {
                                                return dayjs.utc(formData === null || formData === void 0 ? void 0 : formData.EffectiveFROM).format('DD MMM, YYYY');
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'EffectiveTo',
                                            label: 'Effective to date:',
                                            value: null,
                                            // value: `${crud[vehicleHistoryKeys.InstallBaseListKey]?.data?.InstallBase[0]?.VinNo ?? '-'}`,
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                color: 'secondary.600'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            color: 'text.primary',
                                            columnSize: 12,
                                            textAlign: 'end',
                                            valueGetter: function (formData) {
                                                return dayjs.utc(formData === null || formData === void 0 ? void 0 : formData.EffectiveTo).format('DD MMM, YYYY');
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'MinUsage',
                                            label: 'Min KM usage :',
                                            // value: crud[vehicleHistoryKeys.InstallBaseListKey]?.data?.InstallBase[0].SalesInvoiceDate
                                            //     ? dayjs(crud[vehicleHistoryKeys.InstallBaseListKey]?.data?.InstallBase[0].SalesInvoiceDate).format('DD MMM, YYYY')
                                            //     : '-',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                color: 'secondary.600'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            color: 'text.primary',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'MaxUsage',
                                            label: 'Max KM usage :',
                                            // value: crud[vehicleHistoryKeys.InstallBaseListKey]?.data?.InstallBase[0].SalesInvoiceDate
                                            //     ? dayjs(crud[vehicleHistoryKeys.InstallBaseListKey]?.data?.InstallBase[0].SalesInvoiceDate).format('DD MMM, YYYY')
                                            //     : '-',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                color: 'secondary.600'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            color: 'text.primary',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'IsAvailed',
                                            label: 'Availed :',
                                            // value: crud[vehicleHistoryKeys.InstallBaseListKey]?.data?.InstallBase[0].SalesInvoiceDate
                                            //     ? dayjs(crud[vehicleHistoryKeys.InstallBaseListKey]?.data?.InstallBase[0].SalesInvoiceDate).format('DD MMM, YYYY')
                                            //     : '-',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                color: 'secondary.600'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            color: 'text.primary',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.IsAvailed) {
                                                    var IsAvailed = formData !== null && formData !== void 0 && formData.IsAvailed ? formData === null || formData === void 0 ? void 0 : formData.IsAvailed : 'No';
                                                    return IsAvailed;
                                                }
                                                else {
                                                    return 'No';
                                                }
                                            }
                                        }]
                                }]
                        }],
                    value: null
                    // value: selectedVinNo ? crud[vehicleHistoryKeys.SeviceHistoryKey]?.data?.IBContractDetails : null,
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'NodocumentFound',
                    columnSize: 12,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    setFieldProps: function (state) {
                        var _state$statusCounts4;
                        var selectedButton = (state === null || state === void 0 ? void 0 : state.SelectedButton) || 'Active';
                        var selectedCount = (state === null || state === void 0 || (_state$statusCounts4 = state.statusCounts) === null || _state$statusCounts4 === void 0 ? void 0 : _state$statusCounts4[selectedButton]) || 0;
                        return {
                            type: FormItemTypes.ContainerItem,
                            sx: {
                                display: selectedCount > 0 ? 'none' : 'inline-flex'
                            }
                        };
                    },
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: 'noDocumnentFount',
                            children: /*#__PURE__*/ React.createElement(NoDocumenetsIcon, null),
                            columnSize: 0,
                            sx: {
                                color: 'info.600',
                                p: 0,
                                cursor: 'none'
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'title',
                            children: '',
                            columnSize: 12,
                            fontSize: 'xl',
                            fontWeight: 'strong',
                            textAlign: 'center',
                            color: 'text.primary',
                            setFieldProps: function (state) { return ({
                                type: FormItemTypes.Typography,
                                children: 'No contracts found'
                            }); }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'title',
                            children: 'No contracts are present as this moment',
                            columnSize: 12,
                            fontSize: 'base',
                            fontWeight: 'normal',
                            color: 'text.tertiary',
                            textAlign: 'center'
                        }]
                }]
        })
    ];
    var otherDetails = [
        //Customer History
        // ...BasicAndVehicleDetails,
        isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'customerHistory',
            label: '',
            value: null,
            sx: {
                bgcolor: 'white',
                borderLeft: 'none',
                borderRight: 'none',
                borderRadius: 0
            },
            containerProps: {
                spacing: 0
            },
            detailPanelProps: {
                p: 2
            },
            summaryProps: {
                sx: {
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex'
                }
            },
            summary: [{
                    type: FormItemTypes.Typography,
                    name: 'CustomerHistory',
                    label: '',
                    value: null,
                    children: 'Ownership Details',
                    columnSize: 0,
                    fontWeight: 'strong',
                    fontSize: 'lg',
                    color: 'text.primary'
                }, {
                    type: FormItemTypes.Chip,
                    name: 'customer-detail-count',
                    columnSize: 0,
                    size: 'small',
                    variant: 'outlined',
                    color: 'info',
                    valueGetter: function (formValues, field) {
                        return (formValues === null || formValues === void 0 ? void 0 : formValues.IBCustomerDetails.length) || 0;
                    },
                    sx: {
                        ml: '8px'
                    },
                    setFieldProps: function (formValues, currValue) {
                        var _formValues$IBCustome;
                        return {
                            type: FormItemTypes.Chip,
                            hidden: !((formValues === null || formValues === void 0 || (_formValues$IBCustome = formValues.IBCustomerDetails) === null || _formValues$IBCustome === void 0 ? void 0 : _formValues$IBCustome.length) > 0)
                        };
                    }
                }],
            elements: [{
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 12,
                    variant: 'fullWidth'
                }, {
                    type: FormItemTypes.List,
                    name: 'IBCustomerDetails',
                    columnSize: 12,
                    variant: 'compact',
                    value: selectedVinNo ? (_crud$vehicleHistoryK45 = crud[vehicleHistoryKeys.SeviceHistoryKey]) === null || _crud$vehicleHistoryK45 === void 0 || (_crud$vehicleHistoryK45 = _crud$vehicleHistoryK45.data) === null || _crud$vehicleHistoryK45 === void 0 ? void 0 : _crud$vehicleHistoryK45.IBCustomerDetails : null,
                    disableCheckboxSelection: true,
                    sx: {
                        border: '1px solid secondary.200',
                        borderCollapse: 'collapse'
                    },
                    cellStyles: {
                        bgcolor: "secondary.50",
                        borderTop: '1px solid',
                        borderBottom: '1px solid',
                        borderCollapse: 'collapse',
                        borderColor: 'secondary.200'
                    },
                    columns: [{
                            field: '',
                            flex: 1,
                            renderCell: function (params) {
                                var _params$row2;
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    sx: {
                                        fontSize: 'base',
                                        fontWeight: 'medium',
                                        color: 'text.primary'
                                    }
                                }, params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.Customername));
                            }
                        }],
                    elements: CustomerHistoryMobileView
                }],
            columnSize: 12
        } : _objectSpread({
            type: FormItemTypes.Custom,
            name: "IBCustomerDetails",
            element: CustomerHistoryCatalogView,
            columnSize: 12
        }, selectedVinNo ? {} : {
            setFieldProps: function (state) {
                return {
                    type: FormItemTypes.Custom,
                    hidden: state.success && state !== null && state !== void 0 && state.Value ? false : true
                };
            }
        }),
        // Recall Details
        isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'recall',
            label: '',
            value: null,
            sx: {
                bgcolor: 'white',
                borderLeft: 'none',
                borderRight: 'none',
                borderRadius: 0
            },
            summaryProps: {
                sx: {
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex'
                }
            },
            detailPanelProps: {
                p: 2
            },
            summary: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    label: '',
                    value: null,
                    children: 'Recall Details',
                    columnSize: 0,
                    fontWeight: 'strong',
                    fontSize: 'lg',
                    color: 'text.primary'
                }, {
                    type: FormItemTypes.Chip,
                    name: 'recall-detail-count',
                    columnSize: 0,
                    size: 'small',
                    variant: 'outlined',
                    color: 'info',
                    valueGetter: function (formValues, field) {
                        return (formValues === null || formValues === void 0 ? void 0 : formValues.RetroFitmentDetails.length) || 0;
                    },
                    sx: {
                        ml: '8px'
                    },
                    setFieldProps: function (formValues, currValue) {
                        var _formValues$RetroFitm;
                        return {
                            type: FormItemTypes.Chip,
                            hidden: !((formValues === null || formValues === void 0 || (_formValues$RetroFitm = formValues.RetroFitmentDetails) === null || _formValues$RetroFitm === void 0 ? void 0 : _formValues$RetroFitm.length) > 0)
                        };
                    }
                }],
            elements: [{
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 12,
                    variant: 'fullWidth'
                }, {
                    type: FormItemTypes.List,
                    name: 'RetroFitmentDetails',
                    columnSize: 12,
                    variant: 'compact',
                    value: null,
                    disableCheckboxSelection: true,
                    sx: {
                        border: '1px solid secondary.200',
                        borderCollapse: 'collapse'
                    },
                    cellStyles: {
                        bgcolor: "secondary.50",
                        borderTop: '1px solid',
                        borderBottom: '1px solid',
                        borderCollapse: 'collapse',
                        borderColor: 'secondary.200'
                    },
                    columns: [{
                            field: '',
                            flex: 1,
                            renderCell: function (params) {
                                var _params$row3;
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    sx: {
                                        fontSize: 'base',
                                        fontWeight: 'medium',
                                        color: 'text.primary'
                                    }
                                }, params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.RecallName));
                            }
                        }],
                    elements: RecallHistoryMobileView
                }],
            columnSize: 12
        } : _objectSpread({
            type: FormItemTypes.Custom,
            name: "RetroFitmentDetails",
            element: RecallDetailsCatalogView,
            columnSize: 12
        }, selectedVinNo ? {} : {
            setFieldProps: function (state) {
                return {
                    type: FormItemTypes.Custom,
                    hidden: state.success && state !== null && state !== void 0 && state.Value ? false : true
                };
            }
        }),
        // Transaction Details
        isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'transactionDetails',
            label: '',
            value: null,
            sx: {
                bgcolor: 'white',
                borderLeft: 'none',
                borderRight: 'none',
                borderRadius: 0
            },
            summaryProps: {
                sx: {
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex'
                }
            },
            detailPanelProps: {
                p: 2
            },
            summary: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    label: '',
                    value: null,
                    children: 'Transaction Details',
                    columnSize: 0,
                    fontWeight: 'strong',
                    fontSize: 'lg',
                    color: 'text.primary'
                }, {
                    type: FormItemTypes.Chip,
                    name: 'transaction-detail-count',
                    columnSize: 0,
                    size: 'small',
                    variant: 'outlined',
                    color: 'info',
                    valueGetter: function (formValues, field) {
                        return (formValues === null || formValues === void 0 ? void 0 : formValues.TransactionHistory.length) || 0;
                    },
                    sx: {
                        ml: '8px'
                    },
                    setFieldProps: function (formValues, currValue) {
                        var _formValues$Transacti;
                        return {
                            type: FormItemTypes.Chip,
                            hidden: !((formValues === null || formValues === void 0 || (_formValues$Transacti = formValues.TransactionHistory) === null || _formValues$Transacti === void 0 ? void 0 : _formValues$Transacti.length) > 0)
                        };
                    }
                }],
            elements: [{
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 12,
                    variant: 'fullWidth'
                }, {
                    type: FormItemTypes.List,
                    name: 'TransactionHistory',
                    columnSize: 12,
                    variant: 'compact',
                    value: null,
                    disableCheckboxSelection: true,
                    sx: {
                        border: '1px solid secondary.200',
                        borderCollapse: 'collapse'
                    },
                    cellStyles: {
                        bgcolor: "secondary.50",
                        borderTop: '1px solid',
                        borderBottom: '1px solid',
                        borderCollapse: 'collapse',
                        borderColor: 'secondary.200'
                    },
                    columns: [{
                            field: '',
                            flex: 1,
                            renderCell: function (params) {
                                var _params$row4;
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    sx: {
                                        fontSize: 'base',
                                        fontWeight: 'medium',
                                        color: 'text.primary'
                                    }
                                }, params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.CompanyName));
                            }
                        }],
                    elements: TransactionDetailsMobileView
                }],
            columnSize: 12
        } : _objectSpread({
            type: FormItemTypes.Custom,
            name: "TransactionHistory",
            element: TransactionHistoryCatalogView,
            columnSize: 12
        }, selectedVinNo ? {} : {
            setFieldProps: function (state) {
                return {
                    type: FormItemTypes.Custom,
                    hidden: state.success && state !== null && state !== void 0 && state.Value ? false : true
                };
            }
        })
    ];
    var isFormLoading = crud[getLoadingKey("FormLoadingKey")] === "loading";
    var otherDetail = {
        id: 'other-Details',
        Name: 'Other Details',
        elements: otherDetails,
        containerProps: {
            paddingX: {
                xs: '16px',
                sm: '24px'
            }
        }
    };
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'outerContainer',
            spacing: 0,
            columnSize: 12,
            children: isFormLoading ? /*#__PURE__*/ React.createElement(Stack, {
                alignItems: "center",
                justifyContent: "center",
                sx: {
                    minHeight: 100
                }
            }, /*#__PURE__*/ React.createElement(CircularProgress, {
                size: 20
            })) : null,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: 'header',
                    columnSize: 12,
                    gap: '20px',
                    sx: {
                        bgcolor: 'secondary.50'
                    },
                    height: '75px',
                    elements: [{
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            alignItems: 'center',
                            padding: '16px 24px 0px 16px',
                            gap: '16px',
                            elements: [selectedVinNo ? {
                                    type: FormItemTypes.IconButton,
                                    name: '',
                                    children: /*#__PURE__*/ React.createElement(LeftArrow, null),
                                    sx: {
                                        color: 'secondary.600'
                                    },
                                    columnSize: 0,
                                    onClick: function () {
                                        onClose === null || onClose === void 0 || onClose(false);
                                    }
                                } : null, {
                                    type: FormItemTypes.Box,
                                    name: '',
                                    display: 'flex',
                                    columnSize: true,
                                    alignItems: 'center',
                                    sx: {
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        justifyContent: {
                                            xs: 'space-between',
                                            sm: 'flex-start'
                                        }
                                    },
                                    gap: '12px',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'VehicleHistory',
                                            value: 'Vehicle History',
                                            fontWeight: 'strong',
                                            fontSize: 'xxl',
                                            columnSize: 0,
                                            color: 'text.primary',
                                            sx: {
                                                whiteSpace: 'nowrap'
                                            }
                                        }]
                                }]
                        }],
                    setFieldProps: function (formValues, currValue, field, formApi) {
                        return {
                            type: FormItemTypes.ContainerItem
                        };
                    }
                }, !selectedVinNo ? {
                    type: FormItemTypes.Box,
                    name: '',
                    height: '68px',
                    padding: '12px 24px',
                    gap: '12px',
                    bgcolor: 'secondary.100',
                    borderTop: '1px solid ',
                    borderBottom: '1px solid',
                    borderColor: 'secondary.200',
                    columnSize: 12,
                    justifyContent: 'space-between',
                    display: 'flex',
                    elements: [{
                            type: FormItemTypes.Stack,
                            name: 'actions',
                            direction: 'row',
                            alignItems: 'center',
                            columnGap: 0.5,
                            borderRadius: 2,
                            px: 1.25,
                            py: 0.5,
                            border: '1px solid',
                            borderColor: 'secondary.300',
                            bgcolor: 'white',
                            width: '100%',
                            maxWidth: 400,
                            elements: [{
                                    type: FormItemTypes.SingleSelect,
                                    name: 'Key',
                                    value: searchType[0].id,
                                    options: searchType,
                                    displayExpr: 'label',
                                    variant: 'standard',
                                    disableUnderline: true,
                                    sx: {
                                        minWidth: 90
                                    },
                                    columnSize: 0,
                                    setFormState: function () { return ({
                                        Value: ''
                                    }); },
                                    slotProps: {
                                        input: {
                                            sx: {
                                                p: 0
                                            }
                                        }
                                    }
                                }, {
                                    type: FormItemTypes.TextInput,
                                    name: 'Value',
                                    columnSize: true,
                                    variant: 'standard',
                                    placeholder: 'Search by Reg. No, VIN No, Engine No',
                                    // valueSetter: (state, currValue, field) => {
                                    //     const prevValue = state?.[field.name]
                                    //     const newValue = currValue?.trim()
                                    //     let maxLength;
                                    //     switch (state?.Key) {
                                    //         case 'RegistrationNo':
                                    //             maxLength = 10;
                                    //             break;
                                    //         case 'EngineNo':
                                    //             maxLength = 11;
                                    //             break;
                                    //         case 'VinNo':
                                    //             maxLength = 17;
                                    //             break;
                                    //         default:
                                    //             maxLength = undefined;
                                    //     }
                                    //     if (maxLength && newValue?.length > maxLength) return { [field.name]: prevValue }
                                    //     return { [field.name]: currValue?.trim() }
                                    // },
                                    setFormState: function () {
                                        return {
                                            resultnotfound: false,
                                            success: false
                                        };
                                    },
                                    onKeyDown: function (e) {
                                        if (e.key === ' ') {
                                            e.preventDefault();
                                        }
                                    },
                                    onPaste: function (e) {
                                        var pasted = e.clipboardData.getData('text');
                                        if (/\s/.test(pasted)) {
                                            e.preventDefault();
                                        }
                                    },
                                    setFieldProps: function (formValues) {
                                        var maxLength = null;
                                        switch (formValues === null || formValues === void 0 ? void 0 : formValues.Key) {
                                            case 'RegistrationNo':
                                                maxLength = 12;
                                                break;
                                            // case 'EngineNo':
                                            //     maxLength = 11;
                                            //     break;
                                            case 'VinNo':
                                                maxLength = 17;
                                                break;
                                            default:
                                                maxLength = null;
                                        }
                                        return {
                                            InputProps: {
                                                disableUnderline: true,
                                                inputProps: {
                                                    maxLength: maxLength
                                                }
                                            }
                                        };
                                    }
                                }, {
                                    type: FormItemTypes.IconButton,
                                    name: 'ClearButton',
                                    columnSize: 0,
                                    color: 'secondary',
                                    children: /*#__PURE__*/ React.createElement(ClearIcon, {
                                        color: "secondary"
                                    }),
                                    setFieldProps: function (state) {
                                        var _state$Value;
                                        // const valueLength = state?.Value?.length || 0;
                                        // const shouldShow =
                                        //     // (state?.Key === 'RegistrationNo' && state?.Value?.length > 0 && state?.Value?.length !== 10) ||
                                        //     (state?.Key === 'RegistrationNo' && valueLength > 0) ||
                                        //     (state?.Key === 'VinNo' && state?.Value?.length > 0 && state?.Value?.length !== 17) ||
                                        //     (state?.Key === 'EngineNo' && valueLength > 0);
                                        // let shouldDisplay = false;
                                        // if (state?.Key === 'RegistrationNo' || state?.Key === 'EngineNo') {
                                        //     const valueLength = state?.Value?.length || 0;
                                        //     shouldDisplay =
                                        //         ((valueLength && state?.success === true) || state?.resultnotfound) && state?.Value
                                        // } else {
                                        //     shouldDisplay =
                                        //         (shouldShow || state?.resultnotfound || state?.success) && state?.Value;
                                        // }
                                        return {
                                            hidden: !(state !== null && state !== void 0 && (_state$Value = state.Value) !== null && _state$Value !== void 0 && _state$Value.length)
                                        };
                                    },
                                    setFormState: function () { return ({
                                        Value: null,
                                        success: false,
                                        resultnotfound: false
                                    }); }
                                }, {
                                    type: FormItemTypes.IconButton,
                                    name: 'searchButton',
                                    columnSize: 0,
                                    color: 'secondary',
                                    disabled: isSearchLoading,
                                    children: isSearchLoading ? /*#__PURE__*/ React.createElement(CircularProgress, {
                                        size: 20
                                    }) : /*#__PURE__*/ React.createElement(Search, {
                                        color: "secondary"
                                    }),
                                    setFormState: handleClickSearch,
                                    setFieldProps: function (state) {
                                        var _state$Value2, _state$Value3, _state$Value4, _state$Value5;
                                        var showSearch = (state === null || state === void 0 ? void 0 : state.Key) === 'RegistrationNo' && (state === null || state === void 0 || (_state$Value2 = state.Value) === null || _state$Value2 === void 0 ? void 0 : _state$Value2.length) > 2 || (state === null || state === void 0 ? void 0 : state.Key) === 'VinNo' && (state === null || state === void 0 || (_state$Value3 = state.Value) === null || _state$Value3 === void 0 ? void 0 : _state$Value3.length) > 2 && (state === null || state === void 0 || (_state$Value4 = state.Value) === null || _state$Value4 === void 0 ? void 0 : _state$Value4.length) == 17 || (state === null || state === void 0 ? void 0 : state.Key) === 'EngineNo' && (state === null || state === void 0 || (_state$Value5 = state.Value) === null || _state$Value5 === void 0 ? void 0 : _state$Value5.length) > 2;
                                        var showSearchIcon = showSearch && !(state !== null && state !== void 0 && state.success);
                                        return {
                                            type: FormItemTypes.IconButton,
                                            sx: {
                                                display: showSearchIcon && !(state !== null && state !== void 0 && state.resultnotfound) ? 'inline-flex' : 'none'
                                            }
                                        };
                                    }
                                }]
                        }]
                } : null, _objectSpread(_objectSpread({
                    type: FormItemTypes.Tabs,
                    name: 'Tab',
                    columnSize: 12,
                    valueExpr: 'id',
                    displayExpr: 'Name',
                    sx: {
                        paddingX: '24px'
                    },
                    panelGridProps: {
                        spacing: 0,
                        rowGap: '20px',
                        paddingX: '24px'
                    }
                }, selectedVinNo ? {} : {
                    setFieldProps: function (state) { return ({
                        type: FormItemTypes.Tabs,
                        sx: {
                            display: state !== null && state !== void 0 && state.success && state !== null && state !== void 0 && state.Value ? undefined : 'none'
                        }
                    }); }
                }), {}, {
                    tabs: __spreadArray([{
                            id: 'service-history',
                            Name: 'Service History',
                            elements: serviceHistory
                        }, {
                            id: 'contract-History',
                            Name: 'Contract Details',
                            elements: contractHistory
                        }], (!isMobile ? [otherDetail] : []), true)
                }, selectedVinNo ? {} : {
                    setFieldProps: function (state) { return ({
                        type: FormItemTypes.Tabs,
                        stackContainerProps: {
                            display: state !== null && state !== void 0 && state.success && state !== null && state !== void 0 && state.Value ? undefined : 'none'
                        }
                    }); }
                }), {
                    type: FormItemTypes.Stack,
                    name: '',
                    spacing: 0,
                    columnSize: 12,
                    width: '100%',
                    pt: 6,
                    alignItems: 'center',
                    setFieldProps: function (state) { return ({
                        hidden: !(state !== null && state !== void 0 && state.resultnotfound)
                    }); },
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            color: 'secondary',
                            variant: 'outlined',
                            size: 'icon',
                            disabled: true,
                            children: /*#__PURE__*/ React.createElement(Search, {
                                color: "secondary"
                            }),
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'Result not found',
                            fontSize: 'lg',
                            fontWeight: 'strong',
                            textAlign: 'center',
                            columnSize: 12,
                            color: 'text.primary',
                            containerProps: {
                                mt: 2
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 12,
                            maxWidth: 270,
                            color: 'text.tertiary',
                            textAlign: 'center',
                            valueGetter: function (state) {
                                return "Your search \u201C".concat(state === null || state === void 0 ? void 0 : state.Value, "\u201D did not match any ").concat(state === null || state === void 0 ? void 0 : state.Key, ". Please try again.");
                            }
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            paddingTop: {
                xs: 0,
                sm: 0,
                md: selectedVinNo ? '70px' : 0
            }
        }
    }, IS_DESKTOP && /*#__PURE__*/ React.createElement(DesktopTabComponent, null), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        gridProps: {
            spacing: '5px',
            bgcolor: 'secondary.50'
        },
        getKey: "FormLoadingKey",
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            var _getServiceHistory4, _getServiceHistory5, _getInstallbaseData12, _getCustomerData5, _getServiceHistory6, loaderKey, getInstallbaseData, getCustomerData, getServiceHistory, _getInstallbaseData8, _getInstallbaseData9, _getCustomerData3, _getCustomerData4, _getInstallbaseData10, _getInstallbaseData11, selectedStatus, filteredContracts, statusCounts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loaderKey = getLoadingKey('FormLoadingKey');
                        dispatch(setReducerState({
                            key: loaderKey,
                            value: 'loading'
                        }));
                        if (!selectedVinNo) return [3 /*break*/, 5];
                        return [4 /*yield*/, InstallBaseListAPI({
                                request: {
                                    Value: selectedVinNo,
                                    Key: "VinNo"
                                }
                            })];
                    case 1:
                        getInstallbaseData = _a.sent();
                        if (!(((_getInstallbaseData8 = getInstallbaseData) === null || _getInstallbaseData8 === void 0 ? void 0 : _getInstallbaseData8.statusCode) === 200 && (_getInstallbaseData9 = getInstallbaseData) !== null && _getInstallbaseData9 !== void 0 && _getInstallbaseData9.success)) return [3 /*break*/, 3];
                        return [4 /*yield*/, getCustomerDetailsAPI({
                                request: {
                                    id: (_getInstallbaseData10 = getInstallbaseData) === null || _getInstallbaseData10 === void 0 || (_getInstallbaseData10 = _getInstallbaseData10.data) === null || _getInstallbaseData10 === void 0 || (_getInstallbaseData10 = _getInstallbaseData10.Customer) === null || _getInstallbaseData10 === void 0 ? void 0 : _getInstallbaseData10.CustomerId
                                }
                            })];
                    case 2:
                        getCustomerData = _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!(((_getCustomerData3 = getCustomerData) === null || _getCustomerData3 === void 0 ? void 0 : _getCustomerData3.statusCode) === 200 && (_getCustomerData4 = getCustomerData) !== null && _getCustomerData4 !== void 0 && _getCustomerData4.success)) return [3 /*break*/, 5];
                        return [4 /*yield*/, serviceHistoryAPI({
                                request: {
                                    InstallBaseId: (_getInstallbaseData11 = getInstallbaseData) === null || _getInstallbaseData11 === void 0 || (_getInstallbaseData11 = _getInstallbaseData11.data) === null || _getInstallbaseData11 === void 0 || (_getInstallbaseData11 = _getInstallbaseData11.InstallBase) === null || _getInstallbaseData11 === void 0 || (_getInstallbaseData11 = _getInstallbaseData11[0]) === null || _getInstallbaseData11 === void 0 ? void 0 : _getInstallbaseData11.InstallBaseId
                                }
                            })];
                    case 4:
                        getServiceHistory = _a.sent();
                        _a.label = 5;
                    case 5:
                        selectedStatus = "Active";
                        filteredContracts = filterContractsByStatus(((_getServiceHistory4 = getServiceHistory) === null || _getServiceHistory4 === void 0 || (_getServiceHistory4 = _getServiceHistory4.data) === null || _getServiceHistory4 === void 0 ? void 0 : _getServiceHistory4.IBContractDetails) || [], selectedStatus);
                        statusCounts = getContractStatusCounts(((_getServiceHistory5 = getServiceHistory) === null || _getServiceHistory5 === void 0 || (_getServiceHistory5 = _getServiceHistory5.data) === null || _getServiceHistory5 === void 0 ? void 0 : _getServiceHistory5.IBContractDetails) || []);
                        dispatch(setReducerState({
                            key: loaderKey,
                            value: 'idle'
                        }));
                        return [2 /*return*/, {
                                data: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (_getInstallbaseData12 = getInstallbaseData) === null || _getInstallbaseData12 === void 0 ? void 0 : _getInstallbaseData12.data), (_getCustomerData5 = getCustomerData) === null || _getCustomerData5 === void 0 ? void 0 : _getCustomerData5.data), (_getServiceHistory6 = getServiceHistory) === null || _getServiceHistory6 === void 0 ? void 0 : _getServiceHistory6.data), {}, {
                                    SelectedVinNo: selectedVinNo,
                                    isFromQuickLink: selectedVinNo ? true : false,
                                    NewIBContractDetails: filteredContracts,
                                    SelectedButton: 'Active',
                                    success: true,
                                    statusCounts: statusCounts
                                }),
                                success: true
                            }];
                }
            });
        }); },
        formData: formData
    }));
};
